var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.withInfoText
        ? _c("p", [
            _vm._v(
              "\n\t\tZum Beispiel BMD, SAP FI, Adobe Premiere, Java, AutoCad."
            ),
            _c("br"),
            _vm._v(
              "\n\t\tJede Software, die du beherrscht kann wichtig für deinen Beruf sein - z.B. Programme für Grafik,\n\t\tProgrammierung, Buchhaltung, Musikbearbeitung, Konstruktion, Design, Produktion, Logistik.\n\t"
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("SkillsEdit", {
        attrs: {
          value: _vm.value,
          "none-text": "Ich beherrsche keine weitere Software",
          "self-assessment-placeholder": "- Wie gut kannst du das? -",
          "meta-skill-property": "skillSoftwareSpecial",
          "keyword-placeholder": "Software, Programme eintragen...",
          "keyword-placeholder-further": "Weitere Software eintragen..."
        },
        on: {
          hasItems: function($event) {
            return _vm.$emit("hasItems", $event)
          },
          validChange: function($event) {
            return _vm.$emit("validChange", $event)
          },
          input: function($event) {
            return _vm.$emit("input", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }